<template>
  <v-container fill-height fluid grid-list-xl align-content-start>
    <v-layout justify-center wrap>
      <v-flex md12 style="text-align: right">
        <v-btn @click="$router.push({ path: '/admin/master-payer-report'})">Quarterly Attestation Reports</v-btn>
      </v-flex>
      <v-flex md12 style="text-align: right">
        <v-btn @click="onDownloadMasterpayerChild"><v-icon>mdi-download</v-icon>&nbsp; Masterpayer Child Accounts Report</v-btn>
        <v-btn @click="onDownloadMasterpayerActive"><v-icon>mdi-download</v-icon>&nbsp; Masterpayer Active Accounts Report</v-btn>
        <HelperCsvDownload
              style="display: inline;"
              :data="mPayers"
              dlLabel='All Master Payer Accounts'
              :title="'Masterpayer-list'"
              @csv-download-success="downloadFinished"/>
      </v-flex>
      <v-flex md12>
        <material-card color="orange" title="MasterPayer Accounts" text="List of Created MasterPayer Accounts">
          <v-layout justify-center wrap>
            <v-flex xs12 sm3 md3 offset-md9>
              <v-text-field
                v-model="search"
                label="Search"
                single-line
                hide-details
                append-icon="search"
              />
            </v-flex>
          </v-layout>
          <v-progress-linear
            v-slot:progress
            v-if="masterPayerListLoading"
            color="orange"
            indeterminate/>
          <v-data-table
            :headers="masterPayerHeaders"
            :items="mPayers"
            :search="search"
            :pagination.sync="pagination"
          >
            <template
              slot="headerCell"
              slot-scope="{ header }">
              <span
                class="subheading font-weight-light text-success text-md-left text--darken-3"
                v-text="header.text"
              />
            </template>
            <template v-slot:items="props">
              <td>
                <v-icon
                  small
                  class=""
                  color="primary"
                  flat
                  @click="editItem(props.item)">edit</v-icon>
                <v-icon
                  small
                  class=""
                  color="primary"
                  flat
                  @click="deleteItem(props.item)">delete</v-icon>
                <v-icon
                  small
                  title="Changelogs"
                  class=""
                  color="primary"
                  flat
                  @click="onShowLogs(props.item)">history</v-icon>
              </td>
              <td>{{ props.item.MP_ID }}</td>
              <td>{{ props.item.Agreement }}</td>
              <td>{{ props.item.AWS_Support_Type }}</td>
              <td>{{ props.item.Type }}</td>
              <td>{{ props.item.MP_discount }}</td>
              <td>{{ props.item.MP_uplift }}</td>
              <td>{{ props.item.MP_Business_Rules }}</td>
              <td>{{ props.item.MP_features }}</td>
              <td>{{ props.item.MP_Type }}</td>
              <td>{{ props.item.Grandfathered }}</td>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>
      <v-snackbar v-model="linkedAccountsReportGenerated">
        Report Generated
        <v-btn @click="$store.commit('admin/setLinkedAccountsReportGenerated', false)">Close</v-btn>
      </v-snackbar>
    </v-layout>
    <v-dialog
      v-model="linkedAccountForm.show"
      large
      persistent
      scrollable
      max-width="1000px">
      <v-card>
        <v-card-title>Delete MasterPayer</v-card-title>
        <v-card-text id="linked-account-form-content">
          <v-container>
            <p>Before you can DELETE this Master Payer, the following Acct_ID(s) that are associated with (this master payer) has to be disassociated first.</p>
            <v-data-table
              ref="masterPayerLinkedAccounts"
              :headers="linkedAccountForm.accountHeaders"
              :items="linkedAccountForm.accounts"
              :pagination.sync="mPagination"
              class="accounts-table"
              fixed-header
              item-key="Acct_name"
            >
              <template
                slot="headerCell"
                slot-scope="{ header }">
                <span
                  class="subheading font-weight-light text-success text-md-left text--darken-3"
                  v-text="header.text"
                />
              </template>
              <template v-slot:items="props">
                <tr :active="props.selected">
                  <td>
                    <a
                      href="#"
                      @click="onEditAccount(props.item)">{{ props.item.Acct_ID }}</a>
                  </td>
                  <td title="Account Name">{{ props.item.Acct_name }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-container>
        </v-card-text>
        <v-divider />
        <v-card-actions style="text-align: right">
          <v-spacer/>
          <v-btn @click.stop="linkedAccountForm.show = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data: () => ({
    search: '',
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      totalItems: 0
    },
    mPagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      totalItems: 0
    }
  }),
  computed: {
    ...mapState('admin', ['mPayers', 'masterPayerHeaders', 'masterPayerListLoading', 'linkedAccountForm', 'linkedAccountsReportGenerated'])
  },
  mounted () {
    // this.$store.dispatch('admin/getMasterPayers')
  },
  methods: {
    editItem(item) {
      console.log(item)
      
      let syncConfig = {
        Customer_Id: null,
        Managed_Services: null,
        WBS_code: null,
        IWO_code: null
      }

      if (item.Sync_Config != "None") {
        syncConfig = JSON.parse(item.Sync_Config)
      }

      let payerFields = {
        ...item,
        Sync_Config: syncConfig
      }

      this.$store.commit('admin/openMPayerDialog', {
        show: true,
        type: 'edit',
        fields: payerFields,
        submitLabel: 'Update',
        submitHandler: (customer) => {
          this.$store.dispatch('admin/updateMPayer', customer)
        }
      })
      this.$store.commit('setChangeLogRecord', { id: item.Master_Id, changeFrom: { ...item } }, { root: true })
    },
    deleteItem (item) {
      this.$store.dispatch('admin/checkLinkAccounts', item.Master_Id)
    },
    onEditAccount (item) {
      var self = this
      this.$store.commit('admin/openAccountDialog', {
        show: true,
        type: 'edit',
        showSelectCustomer: false,
        fields: { ...item },
        accountIdExist: true,
        mpIdExist: true,
        submitLabel: 'Update',
        submitHandler: () => {
          this.$store.dispatch('admin/updateAccount')
        },
        closeHandler: (data) => {
          let linkedAccounts = this.$store.state['admin/accountInventory'].masterAccounts.filter(account => account.Master_Id == self.linkedAccountForm.id)
          if (linkedAccounts.length) {
            this.$store.commit('admin/setLinkedAccounts', linkedAccounts)
          } else {
            let masterId = self.linkedAccountForm.id
            let masterPayerId = self.linkedAccountForm.mpid
            // close linkedaccount form
            this.$store.commit('admin/resetLinkedAccounts')
            // show delete masterpayer
            this.$store.commit('showDialog', {
              show: true,
              yesHandler: () => {
                this.$store.dispatch('admin/deleteMasterPayer', masterId)
              },
              noHandler: () => {
                this.$store.commit('showDialog', {
                  show: false
                }, { root: true })
              },
              type: 'confirmation',
              persistent: true,
              title: `Do you want to delete this MasterPayer: ${masterPayerId}?`,
              yesLabel: 'Yes',
              noLabel: 'No'
            }, { root: true })
          }
        }
      })
      this.$store.commit('setChangeLogRecord', { id: item.Acct_ID, changeFrom: { ...item } }, { root: true })
    },
    onShowLogs (item) {
      this.$store.dispatch('showLogRecords', item.Master_Id)
    },
    onDownloadMasterpayerActive () {
      this.$store.dispatch('admin/downloadMasterpayerActiveReport')
    },
    downloadFinished () {
      console.log('all master payer download finished')
    },
    onDownloadMasterpayerChild () {
      this.$store.dispatch('admin/downloadMasterpayerChildReport')
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
